var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"jbtn-file",attrs:{"depressed":"","small":""}},[_c('span',{domProps:{"textContent":_vm._s(_vm.title)}}),_vm._v(" "),_c('input',{attrs:{"capture":"","accept":"image/*","type":"file"},on:{"change":_vm.fileSelected}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-026016d0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/widgets/UploadButton.vue
// module id = 312
// module chunks = 4